/**
 * SingleAlert.jsx
 * Created by michaelbray on 8/6/18.
 */

import React from 'react';
import PropTypes from 'prop-types';

import * as Icons from '../../sharedComponents/icons/Icons';

const propTypes = {
    alertClassName: PropTypes.string,
    alertIcon: PropTypes.node,
    alertTitle: PropTypes.string,
    alert: PropTypes.object,
    closeAlert: PropTypes.func
};

export default class SingleAlert extends React.PureComponent {
    render() {
        return (
            <div className={this.props.alertClassName}>
                <div className="rec-msg">
                    <div className="rec-msg-text">
                        <div className="rec-msg-text-type">
                            <div className="rec-alerts-notification-icon">
                                {this.props.alertIcon}
                            </div>
                            <strong>
                                {this.props.alertTitle}
                            </strong>
                        </div>
                        <div className="rec-msg-text-content">
                            <ul>
                                <li>
                                    {this.props.alert.body}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button className="rec-notification-close" onClick={this.props.closeAlert}>
                        <Icons.IconClose className="rec-icon-close" />
                    </button>
                </div>
            </div>
        );
    }
}

SingleAlert.propTypes = propTypes;
